/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedAppWhiteListRequest
 */
export interface RedAppWhiteListRequest {
    /**
     * 
     * @type {string}
     * @memberof RedAppWhiteListRequest
     */
    redAppId: string;
}

/**
 * Check if a given object implements the RedAppWhiteListRequest interface.
 */
export function instanceOfRedAppWhiteListRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "redAppId" in value;

    return isInstance;
}

export function RedAppWhiteListRequestFromJSON(json: any): RedAppWhiteListRequest {
    return RedAppWhiteListRequestFromJSONTyped(json, false);
}

export function RedAppWhiteListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedAppWhiteListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'redAppId': json['redAppId'],
    };
}

export function RedAppWhiteListRequestToJSON(value?: RedAppWhiteListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'redAppId': value.redAppId,
    };
}

